import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import { useAuthStore } from '../auth.store';

/**
 * Whether the app shows its signed-in chrome (header, page padding). A sign-in flips the store the moment the
 * credentials pass, but the page it navigates to can take a while to be ready; until the route itself has left
 * the sign-in pages, the form stays alone on the screen instead of getting a header on top of it.
 */
export function useSignedInLayout(signInPagesPath: string) {
  const route = useRoute();
  const { isAuthenticated } = storeToRefs(useAuthStore());

  return computed(() => isAuthenticated.value && !route.matched.some((record) => record.path === signInPagesPath));
}
